/**
 * Phase F — Mutation endpoints.
 *
 * All state-machine mutators carry an `If-Match` header containing the
 * table's current `version` for optimistic concurrency control (PRD §4).
 * Backend returns 409 on version mismatch.
 */
import http from "@/api/client";

const ifMatch = (version) =>
  version != null ? { headers: { "If-Match": String(version) } } : {};

// ── State machine mutators ────────────────────────────────────────────────

export async function reserveTable(code, payload, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/reserve`,
    payload,
    ifMatch(version),
  );
  return data;
}

export async function assignTable(code, payload, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/assign`,
    payload,
    ifMatch(version),
  );
  return data;
}

export async function closeTable(code, payload, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/close`,
    payload,
    ifMatch(version),
  );
  return data;
}

export async function clearTable(code, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/clear`,
    {},
    ifMatch(version),
  );
  return data;
}

export async function reassignTable(code, payload, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/reassign`,
    payload,
    ifMatch(version),
  );
  return data;
}

export async function reserveFromOccupied(code, payload, version) {
  const { data } = await http.post(
    `/tables/${encodeURIComponent(code)}/reserve-from-occupied`,
    payload,
    ifMatch(version),
  );
  return data;
}

// ── Dynamic table creation ────────────────────────────────────────────────

export async function createDynamicTable(name) {
  const { data } = await http.post("/tables/dynamic", { name: name || null });
  return data;
}

// ── Categories (bulk) ─────────────────────────────────────────────────────

export async function bulkUpdateCategories(codes, category, add) {
  const { data } = await http.post("/tables/categories/bulk", {
    codes,
    category,
    add,
  });
  return data;
}

// ── App lifecycle ─────────────────────────────────────────────────────────

export async function startBreakfast() {
  const { data } = await http.post("/app/start-breakfast", {});
  return data;
}

export async function resetApp() {
  const { data } = await http.post("/app/reset", {});
  return data;
}

export async function patchAppState(body) {
  const { data } = await http.patch("/app/state", body);
  return data;
}
